import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { InterventionRoomPropertyControllerApi } from '../api/generated';
import { createApiConfiguration } from '../api/apiConfig';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import {
  selectInterventionRoomProperties,
  setInterventionRoomProperties
} from '../store/interventionRoomProperties/interventionRoomPropertiesSlice';
import { showError } from '../store/errorDialog/errorDialogSlice';

export function useInterventionRoomProperties(): void {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const properties = useAppSelector(selectInterventionRoomProperties);

  useEffect(() => {
    if (properties.length > 0) return;
    let cancelled = false;
    const config = createApiConfiguration();
    const api = new InterventionRoomPropertyControllerApi(config);
    void api
      .listInterventionRoomProperties()
      .then((response) => {
        if (!cancelled) dispatch(setInterventionRoomProperties(response.data));
      })
      .catch(() => {
        if (!cancelled) dispatch(showError({ message: t('fetch-error') }));
      });
    return () => {
      cancelled = true;
    };
  }, [properties.length, dispatch, t]);
}
